import { render } from "./Mpesa_Endpoints.vue?vue&type=template&id=a9821a7e"
import script from "./Mpesa_Endpoints.vue?vue&type=script&lang=js"
export * from "./Mpesa_Endpoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__